const requiredField = (field) => (v) => !!v || `${field} es requerido`;

const phoneNumber = (v) => {
  const error = 'Formato incorrecto, debe ser numérico y de 9 dígitos';
  if (v === 0) {
    return error;
  } else if (!v) {
    return true;
  } else {
    return /^[0-9]{9}$/.test(v) || error;
  }
};

const onlyNumbers = (field) => (v) => {
  if (v) {
    return /^[0-9]+$/.test(v) && v > 0 || `${field}, solo debe contener números enteros`;
  }
  return true;
};

const isEmail = (v) => {
  if (v) {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email no es válido';
  }
  return true;
};

const onlyLetters = (field) => (v) => {
  if (v) {
    return /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(v) || `${field} sólo debe contener letras.`;
  }
  return true;
};

export default function (Vue) {
  Vue.mixin({
    methods: {
      $chkRequiredField: requiredField,
      $chkPhoneNumber: phoneNumber,
      $chkOnlyNumbers: onlyNumbers,
      $chkIsEmail: isEmail,
      $chkOnlyLetters: onlyLetters,
    }
  });
}
